import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./EditKeyContactsModal.module.css";
import Input from "shared/@forms/Input";
import { TransitionGroup, CSSTransition } from "react-transition-group";

/**
 * Interactive component. Modal with a form to edit and add key contacts.
 */

export function EditKeyContactsModal({ contacts, isOpen, onSave, onClose }) {
  const [contactsLocal, setContactsLocal] = useState([]);

  useEffect(() => {
    if (contacts) {
      var arr = contacts;
      const count = 5 - contacts.length;
      for (let i = 0; i < count; i++) {
        arr.push({
          position: "",
          firstName: "",
          lastName: "",
          phoneNumber: "",
          email: "",
        });
      }
      setContactsLocal(arr);
    } else {
      var arr = [];
      for (let i = 0; i < 5; i++) {
        arr.push({
          position: "",
          firstName: "",
          lastName: "",
          phoneNumber: "",
          email: "",
        });
      }
      setContactsLocal(arr);
    }
  }, [contacts]);

  function addMoreContacts() {
    var arr = [
      ...contactsLocal,
      {
        position: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
      },
    ];
    setContactsLocal(arr);
  }

  function handleOnChange(row, field, value) {
    var arr = [...contactsLocal];
    switch (field) {
      case "position":
        arr[row].position = value;
        break;
      case "first name":
        arr[row].firstName = value;
        break;
      case "last name":
        arr[row].lastName = value;
        break;
      case "phone number":
        arr[row].phoneNumber = value;
        break;
      case "email":
        arr[row].email = value;
        break;
    }
    setContactsLocal(arr);
  }

  return (
    isOpen && (
      <div className={styles.container}>
        <div className={styles.flex}>
          <div>Key Contacts</div>
          <div className={styles.hr} />

          <div className={styles.contactsContainer}>
            <div className={styles.titleRow}>
              <div className={styles.rowItem}>Position</div>
              <div className={styles.rowItem}>First Name</div>
              <div className={styles.rowItem}>Last Name</div>
              <div className={styles.rowItem}>Phone Number</div>
              <div className={styles.rowItem}>Email</div>
            </div>
          </div>
          <TransitionGroup component="ul">
            {contactsLocal.map((contact, index) => (
              <CSSTransition
                timeout={300}
                onEnter={(e) =>
                  e.lastChild.scrollIntoView({ behavior: "smooth" })
                }
                classNames={{
                  enterActive: styles["height-enter-active"],
                  enter: styles["height-enter"],
                  exit: styles["height-exit"],
                  exitActive: styles["height-exit-active"],
                }}
                key={`${contact} ${index}`}
              >
                <div className={styles.inputRow} key={index}>
                  <div className={styles.inputRowItem}>
                    <Input
                      placeholder={"Position"}
                      value={contact.position}
                      className={styles.input}
                      onChange={(e) =>
                        handleOnChange(index, "position", e.target.key)
                      }
                    />
                  </div>
                  <div className={styles.inputRowItem}>
                    <Input
                      placeholder={"First Name"}
                      value={contact.firstName}
                      className={styles.input}
                      onChange={(e) =>
                        handleOnChange(index, "first name", e.target.key)
                      }
                    />
                  </div>
                  <div className={styles.inputRowItem}>
                    <Input
                      placeholder={"Last Name"}
                      value={contact.lastName}
                      className={styles.input}
                      onChange={(e) =>
                        handleOnChange(index, "last name", e.target.key)
                      }
                    />
                  </div>
                  <div className={styles.inputRowItem}>
                    <Input
                      placeholder={"Phone Number"}
                      value={contact.phoneNumber}
                      className={styles.input}
                      onChange={(e) =>
                        handleOnChange(index, "phone number", e.target.key)
                      }
                    />
                  </div>
                  <div className={styles.rowItem}>
                    <Input
                      placeholder={"Email"}
                      value={contact.email}
                      className={styles.input}
                      onChange={(e) =>
                        handleOnChange(index, "email", e.target.key)
                      }
                    />
                  </div>
                </div>
              </CSSTransition>
            ))}
          </TransitionGroup>

          <div
            className={styles.addContactButton}
            onClick={() => addMoreContacts()}
          >
            + Add more contacts
          </div>
          <button
            className={styles.saveButton}
            onClick={() => {
              onSave(contactsLocal);
              onClose();
            }}
          >
            Save
          </button>
        </div>
      </div>
    )
  );
}

EditKeyContactsModal.propTypes = {
  /**
   * Function called when the save button is clicked.
   */
  onSave: PropTypes.func,
  /**
   * Callback function when the modal is closed.
   */
  onClose: PropTypes.func,
  /**
   * Boolean that determines if the modal is displayed.
   */
  isOpen: PropTypes.bool,
  /**
   * Array of the current key contacts to autofill the input boxes.
   */
  contacts: PropTypes.arrayOf(
    PropTypes.shape({
      position: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      phoneNumber: PropTypes.string,
      email: PropTypes.string,
    })
  ),
};
